module.exports = "static/assets/96d18383c71ad5ceff1152859b46c508.mp3";